import React, { useEffect } from 'react';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import ContactStrip from '../components/common/ContactStrip';
import OrgChartResponsive from '../components/layout/OrgChartResponsive';
import Orgchart  from '../assets/images/orgchart.svg';
import { toUrl } from '../lib/config';

const OrganizasyonSemasiPage: React.FC = () => {
  const DEFAULT_HERO = {
    kicker: 'Hakkımızda',
    title: 'Organizasyon Şeması',
    description:
      'Kurumumuzun yapısını ve işleyişini daha şeffaf bir şekilde gösterebilmek amacıyla oluşturduğumuz organizasyon şeması, farklı birimlerin ve görevlerin birbirleriyle olan ilişkilerini açıkça ortaya koymaktadır. Bu şema sayesinde yönetim kadrosundan sağlık hizmeti sunan ekiplere, idari birimlerden destek birimlerine kadar tüm yapımız anlaşılır ve sistematik bir şekilde sunulmaktadır.',
  };
  const [heroKicker, setHeroKicker] = React.useState<string>('');
  const [heroTitle, setHeroTitle] = React.useState<string>('');
  const [heroDesc, setHeroDesc] = React.useState<string>('');

 useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/page-hero/organizasyon-semasi'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (cancelled) return;
        setHeroKicker((obj.kicker || '').trim());
        setHeroTitle((obj.title || '').trim());
        setHeroDesc((obj.description || '').trim());
      } catch {
        // keep defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <AboutHero
        image={Recete3}
        kicker={heroKicker || DEFAULT_HERO.kicker}
        title={heroTitle || DEFAULT_HERO.title}
        description={heroDesc || DEFAULT_HERO.description}
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />

      <OrgChartResponsive
        src={Orgchart}   // public/altındaki dosya
        title="Yönetim Organizasyon Şeması"
      />


      <ContactStrip />
    </>
  );
};

export default OrganizasyonSemasiPage;
